
  <v-snackbar
  v-model="isVisible"
  :timeout="timeout"
  :color="color"
>
   {{message}}
</v-snackbar>

